import React from "react"
import { useSelector } from "react-redux"
import { Loader as ListLoader } from "../../components"
import { selectLoader } from "../slices/loaderSlice"

export const Loader = () => {
    const isLoading = useSelector(selectLoader)?.isLoading
    return <ListLoader loading={isLoading}  />
}
